import React, { useState, useEffect } from 'react';
import {
  Box,
  Button,
  Checkbox,
  Container,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControl,
  FormControlLabel,
  TextField,
  Typography,
  Alert,
  Snackbar,
  Grid,
  InputLabel,
  MenuItem,
  Select
} from '@mui/material';
import { getReaderIdExist, postRequest, getCameraMode, getReaders } from '../../api/axios';
import { useTranslation } from 'react-i18next';

const NewReader = () => {
  const { t } = useTranslation('global');

  const [serialNumber, setSerialNumber] = useState('');
  const [name, setName] = useState('');
  const [isActive, setIsActive] = useState(false);
  const [errMsg, setErrMsg] = useState('');
  const [succ, setSucc] = useState('');
  const [isAntiPassback, setIsAntiPassback] = useState(false);
  const [accessType, setAccessType] = useState("ulaz");
  const [cooldown, setCooldown] = useState(0);
  const [openDuration, setOpenDuration] = useState(0);
  const [cooldownGroup, setCooldownGroup] = useState("");
  const [readerGroup, setReaderGroup] = useState("");
  const [mode, setMode] = useState("0");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedReaders, setSelectedReaders] = useState([]);
  const [allReaders, setAllReaders] = useState([]);

  const fetchReaders = async () => {
    const response = await getReaders();
    setAllReaders(response);
  };

  const handleReaderChange = (e) => {
    const value = e.target.value;
    setSelectedReaders((prev) => 
      prev.includes(value) 
        ? prev.filter((reader) => reader !== value) 
        : [...prev, value]
    );
  };

  useEffect(() => {
    fetchReaders();
    const fetchMode = async () => {
      const res = await getCameraMode();
      setMode(res);
    }
    fetchMode();
  }, [])

  const handleAccessType = (event) => {
    setAccessType(event.target.value);
  }
  const handleSubmit = async (event) => {
    event.preventDefault();
    // Slanje backendu
    const formData = new URLSearchParams();
    formData.append('serial_num', serialNumber);
    formData.append('name', name);
    formData.append('active', isActive);
    formData.append('anti_passback', isAntiPassback);
    formData.append('cooldown_group', selectedReaders.join(','));
    formData.append('cooldown', cooldown);
    formData.append('open_duration', openDuration)
    formData.append('reader_group', readerGroup);
    const response = await postRequest('/add-readers', formData);
    if (!response.success) {
      setErrMsg(t('newReader.somethingWentWrong'));
    } else {
      setSerialNumber('');
      setName('');
      setIsActive(false);
      setIsAntiPassback(false);
      setAccessType('ulaz');
      setCooldown(0);
      setOpenDuration(0);
      setReaderGroup('');
      setSelectedReaders([]);
      setSucc(t('newReader.successfullyAdded'));
    }
  };

  return (
    <Container maxWidth="sm" sx={{ mt: 4 }}>
      <Box
        component="form"
        onSubmit={handleSubmit}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
          p: 3,
          backgroundColor: '#f9f9f9',
          borderRadius: 2,
          boxShadow: 1,
        }}
      >
        <Typography variant="h4" gutterBottom sx={{ alignSelf: "center" }}>
          {t('newReader.newReader')}
        </Typography>
        <TextField
          id="serialNumber"
          label={t('newReader.serialNumber')}
          variant="outlined"
          value={serialNumber}
          onChange={(e) => setSerialNumber(e.target.value)}
          fullWidth
        />
        <TextField
          id="name"
          label={t('newReader.name')}
          variant="outlined"
          value={name}
          onChange={(e) => setName(e.target.value)}
          fullWidth
        />
        <Box>
          <FormControlLabel
            control={
              <Checkbox
                id="isActive"
                checked={isActive}
                onChange={(e) => setIsActive(e.target.checked)}
              />
            }
            label={t('newReader.active')}
          />
          {mode === "1" && (
            <FormControlLabel
              control={
                <Checkbox
                  id="isAntiPassback"
                  checked={isAntiPassback}
                  onChange={(e) => setIsAntiPassback(e.target.checked)}
                />
              }
              label={t('newReader.antipassback')}
            />
          )}
        </Box>
        <FormControl fullWidth variant="outlined" sx={{ maxWidth: "400px" }} size="small">
          <InputLabel>{t("newReader.accessType")}</InputLabel>
          <Select
            value={accessType}
            label={t("newReader.accessType")}
            onChange={handleAccessType}
          >
            <MenuItem value="ulaz">ulaz</MenuItem>
            <MenuItem value="izlaz">izlaz</MenuItem>
          </Select>
          </FormControl>
        <TextField
          fullWidth
          id="reader_group"
          label={t('editReader.readerGroup')}
          value={readerGroup}
          onChange={(e) => setReaderGroup(e.target.value)}
          variant="outlined"
        />
        {mode === "1" && (
            <TextField
              fullWidth
              id="cooldown"
              label={t('newReader.cooldown')}
              value={cooldown}
              onChange={(e) => setCooldown(e.target.value)}
              variant="outlined"
            />
        )}
          <TextField
            id="openDuration"
            label={t('newReader.openDuration')}
            variant="outlined"
            value={openDuration}
            onChange={(e) => setOpenDuration(e.target.value)}
            fullWidth
          />
        {mode === "1" && (
            <Grid item xs={12}>
                                      <Button variant="outlined" onClick={() => setIsModalOpen(true)}>
                                          {t("editReader.cooldownGroup")}
                                      </Button>
                                  </Grid>
        )}
        <Dialog open={isModalOpen} onClose={() => setIsModalOpen(false)} fullWidth maxWidth="sm">
          <DialogTitle>{t('newReader.selectReader')}</DialogTitle>
          <DialogContent>
            <Grid container spacing={1}>
              {allReaders.map((reader) => (
                <Grid item xs={12} sm={6} key={reader.id}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={selectedReaders.includes(reader.id)}
                        onChange={handleReaderChange}
                        value={reader.id}
                      />
                    }
                    label={reader.name}
                  />
                </Grid>
              ))}
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setIsModalOpen(false)} variant="contained" color="primary">
              {t('editReader.ok')}
            </Button>
          </DialogActions>
        </Dialog>
        <Button type="submit" variant="contained" fullWidth>
          {t('newReader.add')}
        </Button>
      </Box>
      {errMsg && (
        <Snackbar open={Boolean(errMsg)} autoHideDuration={6000} onClose={() => setErrMsg('')}>
          <Alert severity="error" onClose={() => setErrMsg('')}>
            {errMsg}
          </Alert>
        </Snackbar>
      )}
      {succ && (
        <Snackbar open={Boolean(succ)} autoHideDuration={6000} onClose={() => setSucc('')}>
          <Alert severity="success" onClose={() => setSucc('')}>
            {succ}
          </Alert>
        </Snackbar>
      )}
    </Container>
  );
};

export default NewReader;
